var map = {
	"./Archive-Empty.svg": "./src/assets/images/svg/Archive-Empty.svg",
	"./Avatar_Action.svg": "./src/assets/images/svg/Avatar_Action.svg",
	"./Lead.svg": "./src/assets/images/svg/Lead.svg",
	"./Track-Right.svg": "./src/assets/images/svg/Track-Right.svg",
	"./Union.svg": "./src/assets/images/svg/Union.svg",
	"./close-icon.svg": "./src/assets/images/svg/close-icon.svg",
	"./error_xl.svg": "./src/assets/images/svg/error_xl.svg",
	"./form-vector.svg": "./src/assets/images/svg/form-vector.svg",
	"./ia-icon.svg": "./src/assets/images/svg/ia-icon.svg",
	"./icon-add-circle.svg": "./src/assets/images/svg/icon-add-circle.svg",
	"./icon-agenda.svg": "./src/assets/images/svg/icon-agenda.svg",
	"./icon-arrow-right.svg": "./src/assets/images/svg/icon-arrow-right.svg",
	"./icon-beta.svg": "./src/assets/images/svg/icon-beta.svg",
	"./icon-certified-document.svg": "./src/assets/images/svg/icon-certified-document.svg",
	"./icon-chat.svg": "./src/assets/images/svg/icon-chat.svg",
	"./icon-chevron-down.svg": "./src/assets/images/svg/icon-chevron-down.svg",
	"./icon-chevron-left.svg": "./src/assets/images/svg/icon-chevron-left.svg",
	"./icon-chevron-right.svg": "./src/assets/images/svg/icon-chevron-right.svg",
	"./icon-chevron-up.svg": "./src/assets/images/svg/icon-chevron-up.svg",
	"./icon-close-rounded.svg": "./src/assets/images/svg/icon-close-rounded.svg",
	"./icon-dislike.svg": "./src/assets/images/svg/icon-dislike.svg",
	"./icon-documents.svg": "./src/assets/images/svg/icon-documents.svg",
	"./icon-example.svg": "./src/assets/images/svg/icon-example.svg",
	"./icon-html.svg": "./src/assets/images/svg/icon-html.svg",
	"./icon-ia.svg": "./src/assets/images/svg/icon-ia.svg",
	"./icon-info.svg": "./src/assets/images/svg/icon-info.svg",
	"./icon-law.svg": "./src/assets/images/svg/icon-law.svg",
	"./icon-like.svg": "./src/assets/images/svg/icon-like.svg",
	"./icon-link.svg": "./src/assets/images/svg/icon-link.svg",
	"./icon-mail.svg": "./src/assets/images/svg/icon-mail.svg",
	"./icon-microsoft-document-break.svg": "./src/assets/images/svg/icon-microsoft-document-break.svg",
	"./icon-microsoft-document.svg": "./src/assets/images/svg/icon-microsoft-document.svg",
	"./icon-microsoft-excel.svg": "./src/assets/images/svg/icon-microsoft-excel.svg",
	"./icon-microsoft-folder-closed.svg": "./src/assets/images/svg/icon-microsoft-folder-closed.svg",
	"./icon-microsoft-folder-configuration.svg": "./src/assets/images/svg/icon-microsoft-folder-configuration.svg",
	"./icon-microsoft-folder-lock.svg": "./src/assets/images/svg/icon-microsoft-folder-lock.svg",
	"./icon-microsoft-folder-user.svg": "./src/assets/images/svg/icon-microsoft-folder-user.svg",
	"./icon-microsoft-folder-zip.svg": "./src/assets/images/svg/icon-microsoft-folder-zip.svg",
	"./icon-microsoft-html.svg": "./src/assets/images/svg/icon-microsoft-html.svg",
	"./icon-microsoft-img.svg": "./src/assets/images/svg/icon-microsoft-img.svg",
	"./icon-microsoft-mail.svg": "./src/assets/images/svg/icon-microsoft-mail.svg",
	"./icon-microsoft-pdf.svg": "./src/assets/images/svg/icon-microsoft-pdf.svg",
	"./icon-microsoft-ppt.svg": "./src/assets/images/svg/icon-microsoft-ppt.svg",
	"./icon-microsoft-word.svg": "./src/assets/images/svg/icon-microsoft-word.svg",
	"./icon-microsoft-zip.svg": "./src/assets/images/svg/icon-microsoft-zip.svg",
	"./icon-microsoft.svg": "./src/assets/images/svg/icon-microsoft.svg",
	"./icon-money-world.svg": "./src/assets/images/svg/icon-money-world.svg",
	"./icon-send.svg": "./src/assets/images/svg/icon-send.svg",
	"./icon-settings.svg": "./src/assets/images/svg/icon-settings.svg",
	"./icon-setup.svg": "./src/assets/images/svg/icon-setup.svg",
	"./icon-stop-filled.svg": "./src/assets/images/svg/icon-stop-filled.svg",
	"./icon-stop.svg": "./src/assets/images/svg/icon-stop.svg",
	"./icon-up-file.svg": "./src/assets/images/svg/icon-up-file.svg",
	"./icon-video.svg": "./src/assets/images/svg/icon-video.svg",
	"./info_xl.svg": "./src/assets/images/svg/info_xl.svg",
	"./logout.svg": "./src/assets/images/svg/logout.svg",
	"./not-found.svg": "./src/assets/images/svg/not-found.svg",
	"./quote.svg": "./src/assets/images/svg/quote.svg",
	"./success_xl.svg": "./src/assets/images/svg/success_xl.svg",
	"./warning_xl.svg": "./src/assets/images/svg/warning_xl.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/svg sync recursive ^\\.\\/.*$";